import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-100 py-16 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12">
          <div className="space-y-4">
            <Link to="/" className="inline-block mb-6">
              <img 
                src="https://assets.auxodev.dk/assets/edaf948a-4a1a-4ebb-aa02-f27510a0c213/img-dbc532a3-2273-4dd3-92e4-7aeeba04b09c-v2_1.png" 
                alt="Green Energy Consulting Logo" 
                className="h-10 w-auto object-contain" 
              />
            </Link>
            <div className="text-slate-500 text-sm leading-loose">
              <p className="font-bold text-slate-700">Green Energy Consulting ApS</p>
              <p>CVR: 44033065</p>
              <p>Spangvej 3</p>
              <p className="mt-4">© {new Date().getFullYear()} Green Energy Consulting. Alle rettigheder forbeholdes.</p>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-12">
            <div>
              <h4 className="text-xs font-bold text-slate-900 uppercase tracking-widest mb-6">Navigation</h4>
              <ul className="space-y-3">
                <li><Link to="/#ydelser" className="text-sm text-slate-500 hover:text-emerald-600 transition-colors">Ydelser</Link></li>
                <li><Link to="/#referencer" className="text-sm text-slate-500 hover:text-emerald-600 transition-colors">Referencer</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-bold text-slate-900 uppercase tracking-widest mb-6">Kontakt</h4>
              <ul className="space-y-3">
                <li><a href="mailto:ml@greenecon.dk" className="text-sm text-slate-500 hover:text-emerald-600 transition-colors">ml@greenecon.dk</a></li>
                <li><a href="tel:+4526465885" className="text-sm text-slate-500 hover:text-emerald-600 transition-colors">26465885</a></li>
                <li><a href="#kontakt" className="text-sm text-slate-500 hover:text-emerald-600 transition-colors">Besked</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
